import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-agora-sdk-ng',
  template: `
    <p>
      ngx-agora-sdk-ng works!
    </p>
  `,
  styles: [
  ]
})
export class NgxAgoraSdkNgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
